<template>
  <div>
    <v-row>
      <v-col>
        <vAlertHeader
          title="Staff Bookings & Appointments"
          :color="getThemeColor"
        ></vAlertHeader>
        <full-calendar
          :events="events"
          :config="calendarConfig"
          @event-click="onEventClick"
          @day-click="onDayClick"
        />
      </v-col>
    </v-row>

    <!-- Booking Dialog -->
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline"
            >{{ editedEvent.id ? "Edit" : "New" }} Booking</span
          >
        </v-card-title>

        <v-card-text>
          <v-form>
            <v-select
              :readonly="!isStaff"
              v-model="editedEvent.staffIDs"
              :items="staff"
              multiple
              label="Select Staff"
              required
            />

            <v-select
              :readonly="!isStaff"
              v-model="editedEvent.rateID"
              :items="rates"
              label="Select Rate"
            />

            <v-select
              :readonly="!isStaff"
              v-if="getUserCompany.industry == 'Agency'"
              label="Agency Fee To Apply"
              :items="agencyFees"
              hide-details="auto"
              v-model="selectedAgencyFee"
              @change="getSelectedAgencyFee()"
            ></v-select>

            <v-select
              :readonly="!isStaff"
              v-model="editedEvent.clientID"
              @change="getSelectedClient"
              :items="clients"
              :label="'Select ' + getCompanyLabels.client"
              required
            />

            <Datetime
              v-model="editedEvent.start"
              label="Start Date & Time"
              format="YYYY-MM-DD H:i:s"
            ></Datetime>

            <Datetime
              v-model="editedEvent.end"
              label="End Date & Time"
              format="YYYY-MM-DD H:i:s"
            ></Datetime>

            <v-text-field
              v-if="showHours"
              :readonly="!isStaff"
              label="Hours Per Each Day"
              v-model="editedEvent.hours"
            ></v-text-field>

            <v-textarea
              :readonly="!isStaff"
              class="mt-2"
              rows="3"
              name="input-7-1"
              label="Description / Notes"
              v-model="editedEvent.description"
              hint="Details of Booking goes in here"
            ></v-textarea>

            <v-select
              :readonly="!isStaff"
              label="Make Private"
              hide-details="auto"
              :items="[
                { text: 'Private', value: 'Yes' },
                { text: 'Public', value: 'No' },
              ]"
              v-model="editedEvent.private"
            ></v-select>

            <AddToInvoiceAndPayslip
              v-if="selectedClient"
              :clientReference="selectedClient.clientReference"
              @get-selected-payroll="getSelectedPayroll"
              @get-selected-invoice="getSelectedInvoice"
            ></AddToInvoiceAndPayslip>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="saveEvent">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import FullCalendar from "vue-full-calendar";
import $ from "jquery";
import axios from "@/plugins/axios";
import clientsJs from "@/plugins/clients";
import eventsJs from "@/plugins/events";
import helpersJs from "@/plugins/helpers";
import vAlertHeader from "@/components/Legos/vAlertHeader.vue";
import Datetime from "@/components/myLibrary/DateTimePicker.vue";
import AddToInvoiceAndPayslip from "./AddToInvoiceAndPayslip.vue";

export default {
  components: {
    vAlertHeader,
    Datetime,
    AddToInvoiceAndPayslip,
    //FullCalendar,
  },
  computed: {
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getAuthenticated() {
      return this.$store.getters.getAuthenticated;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },

    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getRetrieveAllRatesRoute() {
      return this.$store.getters.getRetrieveAllRatesRoute;
    },
    getAllAgencyFeesRoute() {
      return this.$store.getters.getAllAgencyFeesRoute;
    },
    getSaveEventRoute() {
      return this.$store.getters.getSaveEventRoute;
    },
  },
  data() {
    return {
      dialog: false,
      startTimeMenu: false,
      endTimeMenu: false,
      events: [],
      colors: [],
      agencyFees: [],
      status: null,
      editedEvent: {},
      showHours: false,
      staff: [],
      rates: [],
      clients: [],
      selectedClient: null,
      selectedPayrollID: null,
      selectedInvoice: null,
      selectedInvoiceID: null,
      calendarConfig: {
        eventRender: (info) => {
          // Wait for next DOM update cycle
          this.$nextTick(() => {
            //console.log(info);
          });
        },
        contentHeight: 550,
        defaultView: "agendaWeek",
        selectable: true,
        // select: this.getSelectedDateRange,
        eventClick: this.handleEventClick,
        // eventResize: this.handleEventResize,
        // eventDrop: this.handleEventResize,
        editable: true,
        header: {
          left: "prev,next today",
          center: "title",
          right: "month,agendaWeek,agendaDay",
        },
        eventLimit: true,
      },
      selectedAgencyFee: {
        percentage: 0,
        name: "",
      },
    };
  },
  async mounted() {
    await this.getAllRates();
    await this.getAllClients();
    this.colors = helpersJs.getColors();
    if (this.getAuthenticated) {
      this.status = "Yes";
    } else {
      this.status = "No";
    }
    this.getAllEmployees();
    this.getAllEvents();
    if (this.getUserCompany.industry == "Agency") {
      await this.getAllAgencyFees();
    }
  },
  methods: {
    // getSelectedDateRange(eventObject) {
    //   console.log(eventObject);
    // },
    handleEventClick(eventObject) {
      const eventId = eventObject.id;
      const editedEvent = this.events.find((event) => {
        return event.id == eventId;
      });
      this.editedEvent = editedEvent;
      this.editedEvent.rateID = Number(editedEvent.rate_id);
      this.editedEvent.clientID = Number(editedEvent.client_id);
      this.editedEvent.staffIDs = [editedEvent.staff_id];
      this.dialog = true;
    },
    handleEventResize(eventObject) {
      this.eventId = eventObject.event._def.publicId;
      const start = eventObject.event._instance.range.start;
      const end = eventObject.event._instance.range.end;
      this.startDate = start.toISOString().substr(0, 10);
      this.endDate = end.toISOString().substr(0, 10);
      let event = this.calendarOptions.events.filter((event) => {
        return event.id == this.eventId;
      });
      event = event[0];
      this.title = event.title;
      this.description = event.description;
      this.saveEvent();
    },
    getAllEmployees() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken("/auth/get-all-employees", {}, this.getAccessToken)
        .then((staff) => {
          if (staff.length > 0) {
            this.staff = [];
            staff.forEach((staf) => {
              this.staff.push({
                text: `${staf.name} [${staf.id_number}]`,
                value: staf.id,
                id: staf.id,
                name: staf.name,
              });
            });
          }
          this.$store.commit("setLoader", false);
        });
    },
    stripNonDigitsAndCommasFromMoney(amount) {
      return helpersJs.stripNonDigitsAndCommasFromMoney(amount);
    },
    getAllEvents() {
      this.$store.commit("setLoader", true);
      axios
        .postData("/get-all-events", {
          emis: this.getUserCompany.emis,
          status: this.status,
        })
        .then((events) => {
          if (events.length > 0) {
            events.forEach((event) => {
              event.textColor = "#000";
              //#311B92
              //event.editable = true;
              event.backgroundColor =
                this.colors[Math.floor(Math.random() * this.colors.length)];
            });
            this.events = events;
          }
        });
      this.$store.commit("setLoader", false);
    },
    async getAllRates() {
      const rates = await helpersJs.getAllRates(
        this.getApiUrl + this.getRetrieveAllRatesRoute
      );

      if (rates.length > 0) {
        this.rates = [];
        rates.forEach((rate) => {
          this.rates.push({
            text: `${rate.name} [${this.getCurrency}${rate.price}]`,
            value: rate.id,
            id: rate.id,
            name: rate.name,
          });
        });
        this.rates.unshift({
          text: `Free Service [${this.getCurrency} 0]`,
          value: 111222211111222221111,
          id: 111222211111222221111,
          name: "Free Service",
        });
      }
    },
    async getAllAgencyFees() {
      const agencyFees = await eventsJs.getAllAgencyFees(
        this.getApiUrl + this.getAllAgencyFeesRoute,
        this.getAccessToken
      );

      if (agencyFees.length > 0) {
        this.agencyFees = [];
        agencyFees.forEach((fee) => {
          this.agencyFees.push({
            text: `${fee.name} [${fee.percentage}%]`,
            value: fee,
          });
        });
      }
    },
    async getAllClients() {
      this.$store.commit("setLoader", true);
      const clients = await clientsJs.getAllClients();
      this.$store.commit("setLoader", false);
      if (clients.length > 0) {
        this.clients = [];
        clients.forEach((client) => {
          this.clients.push({
            text: client.name | client.institution,
            value: client.id,
            id: client.id,
            clientReference: client.client_reference,
            name: client.institution,
            institution: client.institution,
          });
        });
      }
    },
    getSelectedClient(clientID) {
      this.selectedClient = this.clients.find((c) => c.id == clientID);
    },
    getDifferenceInHours(dt2, dt1) {
      var diff = (new Date(dt2).getTime() - new Date(dt1).getTime()) / 1000;
      diff /= 60 * 60;
      return Math.abs(Math.round(diff));
    },
    onDayClick(date) {

      this.editedEvent = {
        id: null,
        staffIDs: [],
        rateID: null,
        clientID: null,
        description: null,
        private: "No",
        rates: 0,
        hours: 0,
        start: date.format("YYYY-MM-DD HH:mm:ss"),
        end: date.add(1, "hours").format("YYYY-MM-DD HH:mm:ss"),
      };
      //"YYYY-MM-DDTHH:mm:ss"
      this.dialog = true;
    },
    onEventClick({ event }) {
      this.editedEvent = { ...event };
      this.editedEvent.rateID = event.rate_id;
      this.editedEvent.clientID = event.client_id;
      this.editedEvent.staffID = event.staff_id;
      this.editedEvent.staffIDs = [event.staff_id];

      this.dialog = true;
    },
    getSelectedAgencyFee() {
      this.selectedAgencyFee.percentage = this.stripNonDigitsAndCommasFromMoney(
        this.selectedAgencyFee.percentage
      );
      if (this.selectedAgencyFee.percentage > 0) {
        this.selectedAgencyFee.percentage = (
          Number(this.selectedAgencyFee.percentage) / 100
        ).toFixed(2);
      } else {
        return 0;
      }
    },
    getSelectedPayroll(selectedPayroll) {
      this.selectedPayrollID = selectedPayroll.id;
    },
    getSelectedInvoice(selectedInvoice) {
      this.selectedInvoice = selectedInvoice;
      this.selectedInvoiceID = selectedInvoice.id;
    },
    async saveEvent() {
      this.$store.commit("setLoader", true);
      const payload = {
        ...this.editedEvent,
        title: this.getEventTitle(this.editedEvent),
        start: this.editedEvent.start,
        end: this.editedEvent.end,
      };

      const hours = this.getDifferenceInHours(payload.end, payload.start);
      if (hours < 25) {
        payload.hours = hours;
      } else {
        this.showHours = true;
      }

      const events = await eventsJs.saveEvent(
        this.getApiUrl + this.getSaveEventRoute,
        payload,
        this.selectedAgencyFee,
        this.selectedPayrollID,
        this.selectedInvoiceID,
        this.getAccessToken
      );

      this.$store.commit("setLoader", false);

      if (events.length > 0) {
        events.forEach((event) => {
          event.textColor = "#000";
          //event.editable = true;
          event.backgroundColor =
            this.colors[Math.floor(Math.random() * this.colors.length)];
        });
        this.events = events;
        this.$toast.success("Booking / Appointment Captured Successfully!", {
          duration: 3000,
        });
      }

      this.dialog = false;
    },
    getEventTitle(event) {
      // const staff = this.staff.find((s) => s.id == event.staffID);
      const rate = this.rates.find((r) => r.id == event.rateID);
      let rname = "";
      if (!rate) {
        rname = "Free Service";
      } else {
        rname = rate.name;
      }
      const client = this.clients.find((c) => c.id == event.clientID);
      let cinst = "";
      if (!client) {
        cinst = this.getCompanyLabels.client + " Booking";
      } else {
        cinst = client.name + "-" + client.institution;
      }

      return `${rname} - ${cinst}`;
    },
  },
};
</script>

<style scoped>
@import "~fullcalendar/dist/fullcalendar.css";
.headline {
  font-weight: bold;
}
</style>
